import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { IndicateurServiceService } from '../indicateur/indicateur.component';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constant } from 'src/app/shared/service/utils/contant';
import { Indicateur, IndicateurResultat } from 'src/app/shared/models/indicateurs';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-edit-indicateur',
  templateUrl: './edit-indicateur.component.html',
  styleUrl: './edit-indicateur.component.scss'
})
export class EditIndicateurComponent {

  item: IndicateurResultat = new IndicateurResultat()
  typeIndicateurData: any = [];
  projetData: any = [];
  resultatItems:any =[];
  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localstorage: LocalStorageService,
    private FecthDataService: FecthDataService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService


  ) { }


  ngOnInit() {

    this.item = this.localstorage.getIndicateur();
    ////console.log(" this.item", this.item?.libelle);
    const dateValeur = this.localstorage.getIndicateur()?.date_valeur_reference;
    if (dateValeur) {
      const date = new Date(dateValeur);
      // Formater la date au format 'YYYY-MM-DD' pour l'input de type 'date'
      this.item.date_valeur_reference = date.toISOString().split('T')[0];
    }
    ///////console.log("this.item.date_valeur_reference", this.item.date_valeur_reference);


    this.fetchDataProgramme();

  }

  close() {

    this.modalService.dismissAll();
  }


  Edit() {
    const item = this.localstorage.getIndicateur();
    this.ngxService.start();
    this.paramService.editIndicateurs(item.reference, this.item).subscribe(
      (response: any) => {
        ////console.log("la reponse du webservice", response);
        this.FecthDataService.notifySeriviceCreated();
        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.ngxService.stop();
      },
      (error: any) => {
        ////console.log("une erreur est survenu", error);
        // this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });

        this.ngxService.stop();

      }
    )
  }

  //liste des projets
  fetchDataProgramme() {
    this.paramService.fetchDataProgramme().subscribe(
      (response: any) => {
        this.projetData = response.data;
        ////console.log("this.projetData", this.projetData);
        this.getResultatByProgramme(this.item.programme_id);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }//end fetchDataProjet

  //recuperation des indicateurs du projet
  getIndicateurProjet() {
    this.paramService.fetchTypeIndicateur().subscribe(
      (response: any) => {
        this.typeIndicateurData = response.data;
        ////console.log("this.projetData", this.typeIndicateurData);
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }//end getIndicateurProjet


  getResultatByProgramme(item: any) {
    this.paramService.getResultatByProgramme(item).subscribe(
      (response: any) => {
        //console.log("la réponse du webservice", response);
        this.resultatItems = response.data;
        this.getIndicateurProjet();

      },
      (error: any) => {
        //console.log("une erreur est survenu", error);

      }
    )
  }
}